import { useState } from "react";
import { createUseStyles } from "react-jss";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import GenericOptions from "../GenericOptions";
import MovementOptions from "../MovementOptions";
import styles from "./sharedStyles";

const useStyles = createUseStyles({
  ...styles,
});

const EditLinkHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  account,
  images,
  editing,
  targetToolTip,
}) => {
  const [config, setConfig] = useState({ targetToolTip, ...hotspot });
  const classes = useStyles();

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>Edit Movement Hotspot</h1>
          <p className={classes.subtitle}>Move with a little zoom</p>
          <div className={classes.grow} />
        </>
      }
    >
      <div className={classes.options}>
        <GenericOptions
          icon="Direction"
          config={config}
          setConfig={setConfig}
          account={account}
          title={false}
        />
        <MovementOptions
          editing={editing}
          config={config}
          setConfig={setConfig}
          images={images}
          onComplete={onComplete}
        />
      </div>
    </SidebarLightbox>
  );
};

export default EditLinkHotspot;
